import moment from 'moment'
import store from '@/store'
// import treeData from '@/utils/citydata'
import treeData from '@/utils/pcas-code.json'
import { getAgeAndSexByIDNum } from '@/utils/util'

function getMinzu(formData, pageType, minzuList) {
  console.log('民族', formData)
  // eslint-disable-next-line camelcase
  var need_help_person_nation_name = null
  minzuList.forEach((item, index) => {
    if (item.key === formData.need_help_person_nation) {
      // eslint-disable-next-line camelcase
      need_help_person_nation_name = item.title
    }
  })
  if (pageType === 'increase' || pageType === 'edit') {
    return formData.need_help_person_nation || ''
  } else {
    // eslint-disable-next-line camelcase
    return need_help_person_nation_name || '--'
  }
}

// function getQiyongzhuangtaiMoren(formData, pageType) {
//   // alert(formData.need_help_person_status)
//   if (pageType === 'increase' || pageType === 'edit') {
//     return formData.need_help_person_status
//   } else {
//     return formData.need_help_person_status === '0' ? '禁用' : '启用'
//   }
// }

export const forms = {
  getBaseForm(formData, extend, pageType, minzuList, that) {
    var moren = ''
    if (pageType === 'increase' || pageType === 'edit') {
      moren = ''
    } else {
      moren = '--'
    }
    const peopleInfo = getAgeAndSexByIDNum(formData.need_help_person_number_id)
    const getType = (name, type) => {
      if (extend.checkDisabled(name)) {
        return 'text'
      } else {
        return type
      }
    }
    const getAddress = (city = [], address = '') => {
      let newAddress = ''
      if (city) {
        for (let i = 0; i < city.length; i++) {
          newAddress = newAddress + city[i]
        }
      }

      if (address) {
        newAddress = newAddress + address
      }
      return newAddress || '--'
    }
    const data = [
      {
        type: 'text',
        label: '身份证号',
        col: '6',
        defaultValue: formData.need_help_person_number_id || moren,
        id: 'idCard',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_name', 'input'),
        label: '姓名',
        rules: [
          {
            pattern: /^[\u4e00-\u9fa5]{2,6}$/,
            message: '请输入中文并且长度不超过6个字符'
          },
          {
            required: true,
            message: '请填写姓名'
          }
        ],
        col: '6',
        // disabled: extend.checkDisabled,
        onChange: that.xingmingOnchange,
        id: 'need_help_person_name',
        defaultValue: formData.need_help_person_name || moren,
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_gender', 'select'),
        label: '性别',
        rules: [
          {
            required: true,
            message: '请选择性别'
          }
        ],
        col: '6',
        defaultValue: formData.need_help_person_gender || peopleInfo.sex,
        id: 'need_help_person_gender',
        options: [
          {
            label: '男',
            value: '男'
          },
          {
            label: '女',
            value: '女'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_birthday', 'datePicker'),
        label: '出生日期',
        rules: [
          {
            required: true,
            message: '请选择出生日期'
          }
        ],
        disabledDate: (current) => {
          return current && current >= moment().startOf('day')
        },
        // disabled: extend.checkDisabled,
        format: 'YYYY-MM-DD',
        defaultValue: formData.need_help_person_birthday
          ? moment(formData.need_help_person_birthday).format('YYYY-MM-DD')
          : moment(peopleInfo.birthday).format('YYYY-MM-DD'),
        col: '6',
        id: 'need_help_person_birthday',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_age', 'input'),
        label: '年龄',
        rules: [
          {
            pattern: /^[0-9]*$/,
            message: '请输入数字'
          },
          {
            required: true,
            message: '请填写年龄'
          }
        ],
        col: '6',
        onChange: (value) => extend.numberChange(value, 'need_help_person_age_jiegou'),
        id: 'need_help_person_age',
        defaultValue: formData.need_help_person_age || peopleInfo.age,
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_age_jiegou', 'select'),
        label: '年龄结构',
        rules: [
          {
            required: true,
            message: '请选择年龄结构'
          }
        ],
        col: '6',
        options: [
          {
            label: '未成年',
            value: '未成年'
          },
          {
            label: '成年',
            value: '成年'
          },
          {
            label: '老年',
            value: '老年'
          }
        ],
        id: 'need_help_person_age_jiegou',
        defaultValue: formData.need_help_person_age_jiegou || peopleInfo.jiegou,
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_nation', 'select'),
        label: '民族',
        rules: [
          {
            required: true,
            message: '请选择民族'
          }
        ],
        col: '6',
        defaultValue: getMinzu(formData, pageType, minzuList),
        id: 'need_help_person_nation',
        options: store.getters.nationalList || [],
        optionKey: ['key', 'title'],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_phone_number', 'input'),
        label: '联系电话',
        col: '6',
        defaultValue: formData.need_help_person_phone_number || moren,
        rules: [
          {
            validator: (rule, value, callback) => {
              const phone = new RegExp(
                /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/
              )
              const tel = new RegExp(/^0\d{2,3}-?\d{7,8}$/)
              if (!value) {
                return callback()
              }
              if (phone.test(value)) {
                return callback()
              } else if (tel.test(value)) {
                return callback()
              }
              callback(new Error('电话号码输入格式有误'))
            }
          },
          {
            required: true,
            message: '请输入联系电话'
          }
        ],
        id: 'need_help_person_phone_number',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: getType('need_help_person_residence_area', 'cascader'),
      //   label: '户籍区',
      //   col: '12',
      //   id: 'need_help_person_residence_area',
      //   lineFeed: true,
      //   defaultValue: extend.checkDisabled('need_help_person_residence_area') ? getAddress(formData.need_help_person_residence_area) : (formData.need_help_person_residence_area || []),
      //   options: store.getters.streetList || [],
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: getType('need_help_person_registered_address_city', 'cascader'),
        label: '户籍地址',
        rules: [
          {
            required: true,
            message: '请选择户籍地址'
          }
        ],
        // col: '12',
        col: extend.checkDisabled('need_help_person_current_address_city') ? '18' : '12',
        defaultValue: extend.checkDisabled('need_help_person_registered_address_city')
          ? getAddress(
            formData.need_help_person_registered_address_city,
            formData.need_help_person_registered_address_detailed
          )
          : formData.need_help_person_registered_address_city || [],
        id: 'need_help_person_registered_address_city',
        // lineFeed: true,
        options: treeData || [],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_registered_address_detailed', 'input'),
        label: extend.checkDisabled('need_help_person_registered_address_detailed')
          ? '具体地址'
          : '',
        rules: [
          {
            required: true,
            message: '请输入详细地址'
          }
        ],
        col: '6',
        defaultValue: formData.need_help_person_registered_address_detailed,
        id: 'need_help_person_registered_address_detailed',
        layout: {
          labelCol: extend.checkDisabled('need_help_person_current_address_detailed')
            ? '120px'
            : '20px'
        }
      },
      {
        type: 'children',
        name: 'address',
        col: '6'
      },
      {
        type: 'text',
        label: '户籍地址（历史导入数据）',
        col: '24',
        defaultValue: formData.need_help_person_registered_address_city_old + formData.need_help_person_registered_address_detailed,
        id: 'need_help_person_registered_address_city',
        display: formData.need_help_person_registered_address_city_old && (pageType === 'edit' || pageType === 'view'),
        layout: {
          labelCol: '180px'
        }
      },
      {
        type: getType('need_help_person_current_address_city', 'cascader'),
        label: '现居地址',
        rules: [
          {
            required: true,
            message: '请选择现居地址'
          }
        ],
        col: extend.checkDisabled('need_help_person_current_address_city') ? '18' : '12',
        defaultValue: extend.checkDisabled('need_help_person_current_address_city')
          ? getAddress(
            formData.need_help_person_current_address_city,
            formData.need_help_person_current_address_detailed
          )
          : formData.need_help_person_current_address_city || [],
        id: 'need_help_person_current_address_city',
        // lineFeed: true,
        options: treeData || [],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_current_address_detailed', 'input'),
        label: extend.checkDisabled('need_help_person_current_address_detailed') ? '具体地址' : '',
        rules: [
          {
            required: true,
            message: '请输入详细地址'
          }
        ],
        col: '6',
        defaultValue: formData.need_help_person_current_address_detailed,
        id: 'need_help_person_current_address_detailed',
        layout: {
          labelCol: extend.checkDisabled('need_help_person_current_address_detailed')
            ? '120px'
            : '20px'
        }
      },
      {
        type: 'children',
        name: 'address',
        col: '6'
      },
      {
        type: 'text',
        label: '现居地址（历史导入数据）',
        col: '24',
        defaultValue: formData.need_help_person_current_address_city_old + formData.need_help_person_current_address_detailed,
        id: 'need_help_person_registered_address_city',
        display: formData.need_help_person_current_address_city_old && (pageType === 'edit' || pageType === 'view'),
        layout: {
          labelCol: '180px'
        }
      },
      {
        type: getType('need_help_person_incomeYear', 'input'),
        label: '年收入',
        col: '12',
        suffix: '元',
        defaultValue: formData.need_help_person_incomeYear || moren,
        rules: [
          {
            pattern: /^(([0-9]+.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*.[0-9]+)|([0-9]*[1-9][0-9]*)|0)$/,
            message: '请输入数字'
          },
          {
            required: true,
            message: '请填写年收入'
          }
        ],
        id: 'need_help_person_incomeYear',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_unitZip', 'input'),
        label: '邮编',
        // rules: [
        //   {
        //     pattern: /^\d{6,6}$/,
        //     message: '请输入数字长度不超过6个字符'
        //   },
        //   {
        //     required: true,
        //     message: '请填写邮编'
        //   }
        // ],
        col: '6',
        // disabled: extend.checkDisabled,
        id: 'need_help_person_unitZip',
        defaultValue: formData.need_help_person_unitZip || moren,
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_highestLevel', 'select'),
        label: '文化程度',
        col: '6',
        options: [
          {
            label: '无',
            value: '无'
          },
          {
            label: '学龄前儿童',
            value: '学龄前儿童'
          },
          {
            label: '小学',
            value: '小学'
          },
          {
            label: '初中',
            value: '初中'
          },
          {
            label: '中专',
            value: '中专'
          },
          {
            label: '技校',
            value: '技校'
          },
          {
            label: '高中',
            value: '高中'
          },
          {
            label: '大学专科',
            value: '大学专科'
          },
          {
            label: '大学本科',
            value: '大学本科'
          },
          {
            label: '硕士',
            value: '硕士'
          },
          {
            label: '博士',
            value: '博士'
          },
          {
            label: '研究生',
            value: '研究生'
          }
        ],
        defaultValue: formData.need_help_person_highestLevel || moren,
        // onChange: (value) => extend.numberChange(value, 'need_help_person_ensureTime'),
        id: 'need_help_person_highestLevel',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: getType('need_help_person_currentLevel', 'input'),
      //   label: '在读学历',
      //   col: '12',
      //   defaultValue: formData.need_help_person_currentLevel || '',
      //   // onChange: (value) => extend.numberChange(value, 'need_help_person_ensureTime'),
      //   id: 'need_help_person_currentLevel',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: getType('need_help_person_unitName', 'input'),
        label: '单位(学校)名称',
        // rules: [
        //   {
        //     required: true,
        //     message: '请填写姓名'
        //   }
        // ],
        col: '12',
        // disabled: extend.checkDisabled,
        id: 'need_help_person_unitName',
        defaultValue: formData.need_help_person_unitName || moren,
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_mail_address', 'input'),
        label: '邮箱',
        col: '12',
        rules: [
          {
            validator: extend.checkEma
          }
        ],
        defaultValue: formData.need_help_person_mail_address || moren,
        id: 'need_help_person_mail_address',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: getType('need_help_person_unitAddress', 'input'),
      //   label: '单位(学校)地址',
      //   // rules: [
      //   //   {
      //   //     required: true,
      //   //     message: '请填写姓名'
      //   //   }
      //   // ],
      //   col: '12',
      //   // disabled: extend.checkDisabled,
      //   id: 'need_help_person_unitAddress',
      //   defaultValue: formData.need_help_person_unitAddress || '',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_unitTel', 'input'),
      //   label: '单位(学校)电话',
      //   rules: [
      //     {
      //       validator: extend.checkTel
      //     }
      //   ],
      //   // rules: [
      //   //   {
      //   //     required: true,
      //   //     message: '请填写姓名'
      //   //   }
      //   // ],
      //   col: '12',
      //   // disabled: extend.checkDisabled,
      //   id: 'need_help_person_unitTel',
      //   defaultValue: formData.need_help_person_unitTel || '',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_unitZip', 'input'),
      //   label: '单位(学校)邮编',
      //   rules: [
      //     {
      //       validator: extend.checkZip
      //     }
      //   ],
      //   // rules: [
      //   //   {
      //   //     required: true,
      //   //     message: '请填写姓名'
      //   //   }
      //   // ],
      //   col: '12',
      //   // disabled: extend.checkDisabled,
      //   id: 'need_help_person_unitZip',
      //   defaultValue: formData.need_help_person_unitZip || '',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   label: '所在单位',
      //   type: getType('need_help_person_unit', 'input'),
      //   id: 'need_help_person_unit',
      //   defaultValue: formData.need_help_person_unit,
      //   col: '12',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   label: '单位地址',
      //   type: getType('need_help_person_unit_address', 'input'),
      //   id: 'need_help_person_unit_address',
      //   defaultValue: formData.need_help_person_unit_address,
      //   col: '12',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_sickName', 'input'),
      //   label: '疾病名称',
      //   // rules: [
      //   //   {
      //   //     required: true,
      //   //     message: '请填写姓名'
      //   //   }
      //   // ],
      //   col: '12',
      //   // disabled: extend.checkDisabled,
      //   id: 'need_help_person_sickName',
      //   defaultValue: formData.need_help_person_sickName || '',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_sickType', 'input'),
      //   label: '残疾类别',
      //   // rules: [
      //   //   {
      //   //     required: true,
      //   //     message: '请填写姓名'
      //   //   }
      //   // ],
      //   col: '12',
      //   // disabled: extend.checkDisabled,
      //   id: 'need_help_person_sickType',
      //   defaultValue: formData.need_help_person_sickType || '',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_sickLevel', 'input'),
      //   label: '残疾等级',
      //   // rules: [
      //   //   {
      //   //     required: true,
      //   //     message: '请填写姓名'
      //   //   }
      //   // ],
      //   col: '12',
      //   // disabled: extend.checkDisabled,
      //   id: 'need_help_person_sickLevel',
      //   defaultValue: formData.need_help_person_sickLevel || '',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_ensureDate', 'datePicker'),
      //   label: '享保日期',
      //   // disabledDate: (current) => { return current <= moment().startOf('day') },
      //   format: 'YYYY-MM-DD',
      //   defaultValue: extend.checkDisabled('need_help_person_ensureDate') ? (formData.need_help_person_ensureDate ? `${formData.need_help_person_ensureDate}` : '') : (formData.need_help_person_ensureDate ? moment(formData.need_help_person_ensureDate, 'YYYY-MM-DD') : null),
      //   col: '12',
      //   id: 'need_help_person_ensureDate',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_ensureTime', 'input'),
      //   label: '享保时长',
      //   col: '12',
      //   defaultValue: formData.need_help_person_ensureTime || '',
      //   // onChange: (value) => extend.numberChange(value, 'need_help_person_ensureTime'),
      //   id: 'need_help_person_ensureTime',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_poorStatus', 'textarea'),
      //   label: '致贫原因',
      //   col: '24',
      //   defaultValue: formData.need_help_person_poorStatus || '',
      //   // onChange: (value) => extend.numberChange(value, 'need_help_person_ensureTime'),
      //   id: 'need_help_person_poorStatus',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: getType('need_help_person_married', 'select'),
        label: '婚姻状况',
        rules: [
          {
            required: true,
            message: '请选择婚姻状况'
          }
        ],
        defaultValue: formData.need_help_person_married || moren,
        options: [
          {
            label: '未婚',
            value: '未婚'
          },
          {
            label: '离婚',
            value: '离婚'
            // disabled: true
          },
          {
            label: '已婚',
            value: '已婚'
          },
          {
            label: '丧偶',
            value: '丧偶'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        col: '8',
        id: 'need_help_person_married',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_healthyStatus', 'select'),
        label: '健康状况',
        rules: [
          {
            required: true,
            message: '请选择健康状况'
          }
        ],
        defaultValue: formData.need_help_person_healthyStatus || moren,
        options: [
          {
            label: '健康',
            value: '健康'
          },
          {
            label: '一般',
            value: '一般'
            // disabled: true
          },
          {
            label: '差',
            value: '差'
          }
        ],
        col: '8',
        id: 'need_help_person_healthyStatus',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_employment_status', 'select'),
        label: '就业状态',
        rules: [
          {
            required: true,
            message: '请选择就业状态'
          }
        ],
        options: [
          {
            label: '有业',
            value: '有业'
          },
          {
            label: '无业',
            value: '无业'
          },
          {
            label: '退休',
            value: '退休'
          },
          {
            label: '学生',
            value: '学生'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        col: '8',
        id: 'need_help_person_employment_status',
        defaultValue: formData.need_help_person_employment_status || moren,
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_addressType', 'select'),
        label: '户籍性质',
        rules: [
          {
            required: true,
            message: '请选择户籍性质'
          }
        ],
        defaultValue: formData.need_help_person_addressType || moren,
        options: [
          {
            label: '本市农业',
            value: '本市农业'
          },
          {
            label: '本市非农业',
            value: '本市非农业'
            // disabled: true
          },
          {
            label: '非本市农业',
            value: '非本市农业'
          },
          {
            label: '非本市非农业',
            value: '非本市非农业'
          }
        ],
        col: '8',
        id: 'need_help_person_addressType',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_poverty_type', 'select'),
        label: '家庭类别',
        rules: [
          {
            required: true,
            message: '请选择贫困类型'
          }
        ],
        defaultValue: formData.need_help_person_poverty_type || moren,
        options: [
          {
            label: '低保',
            value: '低保'
          },
          {
            label: '低收入',
            value: '低收入'
            // disabled: true
          },
          {
            label: '因病支出型',
            value: '因病支出型'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        col: '8',
        id: 'need_help_person_poverty_type',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: getType('need_help_person_status', 'select'),
      //   label: '启用状态',
      //   rules: [
      //     {
      //       required: true,
      //       message: '请选择启用状态'
      //     }
      //   ],
      //   onChange: that.qiyongzhuantaiOnchange,
      //   defaultValue: getQiyongzhuangtaiMoren(formData, pageType),
      //   options: [
      //     {
      //       label: '启用',
      //       value: '1'
      //     },
      //     {
      //       label: '禁用',
      //       value: '0'
      //       // disabled: true
      //     }
      //   ],
      //   col: '8',
      //   id: 'need_help_person_status',
      //   layout: {
      //     labelCol: '120px'
      //   },
      //   disabled: true
      // },
      {
        type: getType('need_help_person_disable_reason', 'input'),
        label: '禁用原因',
        rules: [
          {
            required: that.jinyongyuanyin_show,
            message: '请填写禁用原因'
          }
        ],
        col: '24',
        // disabled: extend.checkDisabled,
        display: that.jinyongyuanyin_show,
        id: 'need_help_person_disable_reason',
        defaultValue: formData.need_help_person_disable_reason || moren,
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: getType('need_help_person_type', 'radio'),
      //   label: '帮扶类型',
      //   rules: [
      //     {
      //       required: true,
      //       message: '请选择帮扶类型'
      //     }
      //   ],
      //   options: [
      //     {
      //       label: '个人',
      //       value: '个人'
      //     },
      //     {
      //       label: '家庭',
      //       value: '家庭'
      //     }
      //   ],
      //   col: '12',
      //   id: 'need_help_person_type',
      //   lineFeed: true,
      //   defaultValue: formData.need_help_person_type,
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: getType('need_help_person_poor_type', 'radio'),
      //   label: '是否脱贫',
      //   rules: [
      //     {
      //       required: true,
      //       message: '请选择是否脱贫'
      //     }
      //   ],
      //   options: [
      //     {
      //       label: '贫困',
      //       value: '贫困'
      //     },
      //     {
      //       label: '脱贫',
      //       value: '脱贫'
      //     }
      //   ],
      //   col: '12',
      //   id: 'need_help_person_poor_type',
      //   lineFeed: true,
      //   defaultValue: formData.need_help_person_poor_type,
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: 'text',
        id: 'assitLog',
        label: '帮扶日志',
        name: 'assitLog',
        col: '24',
        layout: {
          labelCol: '120px'
        }
      }
    ]
    const newData = []
    for (let i = 0; i < data.length; i++) {
      if (extend.checkDisplay(data[i].id)) {
        newData.push(data[i])
      }
    }
    return newData
  }
}
